export default "__VITE_ASSET__nSayOhKK__"